import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './userForm';
import List from './userList';

const settings = {
    pathRegister: paths.userRegister,
    pathList: paths.user,
    apiPath: 'users',
    permissionAdmin: null,
    title: 'Usuário',
    entity: 'user',
};

const User: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const UserList: React.FC = () => {
    return (
        <MainContainer>
            <List />
        </MainContainer>
    );
};

export { User, UserList };
